<template>
  <div class="modalContent" v-sound>
    <h2 class="orderTitle">注文内訳</h2>
    <hr class="titleLine" />

    <div class="orderList">
      <table class="orderTable">
        <thead>
          <tr> 
            <th>商品名</th>
            <th>数量</th>
            <th>小計</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(order, index) in orderitems" :key="index">
            <td><p v-html="order.menuitems.label"></p></td>
            <td>{{ order.quantity }}</td>
            <td>{{ Math.round(order.quantity * order.menuitems.price / 1.1).toLocaleString() }}円<br>
              (税込{{ (order.quantity * order.menuitems.price).toLocaleString() }}円)
            </td>
          </tr>
          <!-- 空行を追加して10行分を埋める -->
          <tr v-for="index in Math.max(10 - orderitems.length, 0)" :key="'empty-' + index">
            <td>&nbsp;</td>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
          </tr>
        </tbody>
        <tfoot>
          <td class="totalLabel" colspan="2">合計</td>
              <td class="totalAmount">
                {{ Math.round(totalAmount / 1.1).toLocaleString() }}円<br>
                (税込{{ totalAmount.toLocaleString() }}円)</td>
        </tfoot>
      </table>
    </div>
    <div class="buttonContainer">
      <button class="backButton" @click="hideModal">戻る</button>
      <button class="confirmButton" @click="updateTableSessions()">
        <span v-if="data.session.status===1">お会計済みにする</span>
        <span v-else>お会計待ちに戻す</span></button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import PLAN_MAP from '@/data/plan/plans.js';

export default {
  props: {
    data: {
      require: true,
    },
  },
  data() {
    return {
      orderitems: [],
      totalAmount: 0,
      otherMenu: [],
      // ★ プランごとに対象メニューIDを格納するオブジェクト
      planTargetMenuIds: {},
      diningTableID: localStorage.getItem('diningTableID'),
      session: {},
    };
  },
  created() {
    this.session = this.data.session || {};
    this.axios({
      method: 'GET',
      url: '/v1/connection/test',
    })
      .then((response) => {
        console.log(response.data.status);
      })
      .catch((error) => {
        if (error.response) console.log(error.response.data);
        else console.log(error);
      });
    this.getOrderItems();
  },
  computed: {
    ...mapState(['user', 'cart', 'helper']),
  },
  methods: {
    async getOrderItems() {
      await this.getMenus();
      this.axios({
        method: 'GET',
        url: '/v1/orderitem/get/list',
        params: {
          excludeMenu: this.otherMenu[0]?.id,
          includeSession: [this.session.id],
          includeTable: this.session.dining_table_id,
          user_id: this.user.id,
        },
      })
        .then((response) => {
          this.orderitems = response.data.list.data;
          this.applyPlanDiscount();
          this.calculateTotalAmount();
        })
        .catch((error) => {
          if (error.response) console.log(error.response);
          else console.log(error);
        });
    },
    applyPlanDiscount() {
      const planNames = Object.keys(PLAN_MAP);
      const activePlans = this.orderitems
        .filter((order) => planNames.includes(order.menuitems?.name))
        .map((order) => order.menuitems.name);

      if (activePlans.length === 0) return;

      const finalDiscountIds = new Set();
      activePlans.forEach((planName) => {
        if (this.planTargetMenuIds[planName]) {
          this.planTargetMenuIds[planName].forEach((id) => {
            finalDiscountIds.add(id);
          });
        }
      });

      this.orderitems.forEach((order) => {
        if (finalDiscountIds.has(order.menuitems?.menu_id)) {
          order.menuitems.price = 0;
        }
      });
    },
    calculateTotalAmount() {
      this.totalAmount = this.orderitems.reduce(
        (sum, item) => sum + item.quantity * item.menuitems.price,
        0,
      );
    },
    updateTableSessions() {
      this.axios({
        method: 'POST',
        url: '/v1/tablesession/update',
        data: {
          id: this.session.id,
          status: this.session.status === 1 ? 2 : 1, // ステータスを更新
          user_id: this.user.id,
        },
        
      })
        .then((res) => {
          console.log(res.data);
        })
        .catch((error) => {
          if (error.response) console.log(error.response);
          else console.log(error);
        })
        .finally(() => {
          this.hideModal();
          window.location.reload();
        });
    },
    hideModal(payload) {
      this.$store.dispatch('modal/contents/hideModal', payload === 'update' ? payload : null, { root: true });
    },
    getMenus() {
      return new Promise((resolve, reject) => {
        this.axios({
          method: 'GET',
          url: 'v1/menu/get/list',
          params: {
            user_id: this.user.id,
          },
        })
          .then((response) => {
            const allMenus = response.data.list.data;

            this.otherMenu = allMenus.filter((menu) => menu.flag === 2);

            const planTargets = {};
            Object.keys(PLAN_MAP).forEach((planName) => {
              const targetCategories = PLAN_MAP[planName];
              const targetIds = allMenus
                .filter((menu) => targetCategories.includes(menu.name))
                .map((menu) => menu.id);
              planTargets[planName] = targetIds;
            });
            this.planTargetMenuIds = planTargets;

            resolve();
          })
          .catch((error) => {
            if (error.response) console.log(error.response);
            else console.log(error);
            reject(error);
          });
      });
    },
  },
};
</script>

<style scoped>
.modalContent {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #DDD4C1;
  outline: none;
  padding: 5vw 5vh;
  font-family: '游明朝体', 'Yu Mincho', 'ヒラギノ明朝 ProN', 'Hiragino Mincho ProN', serif;
  justify-content: center;
  align-items: center;
}

.orderTitle {
  font-family: 'HGS明朝B', serif;
  font-size: 50px;
  font-weight: bold;
  color: #333;
  text-align: center;
  margin-bottom: 10px;
}

.titleLine {
  width: 100%;
  border: 3px solid #333;
  margin-bottom: 20px;
  text-align: center;
}

.orderList {
  width: 100%;
  height: 50vh;
  overflow-y: auto;
  border: 3px solid #333;
  text-align: center;
  margin: 0 auto;
}

.orderTable {
  width: 100%;
  font-family: '游明朝', serif;
  font-size: 2vw;
  color: #333;
  background-color: transparent;
}

.orderTable th {
  font-size: 2vw;
  font-weight: bold;
  background-color: transparent;
  padding: 10px;
  border: 3px solid #333;
  text-align: center;
  position: sticky;
  top: 0;
  background-color: #DDD4C1;
  white-space: nowrap;
}

.orderTable td {
  font-size: 1.5vw;
  font-weight: normal;
  padding: 10px;
  border: 3px solid #333;
  text-align: center;
  height: 50px;
  background-color: transparent;
  white-space: pre-wrap;
  line-height: 1.2;
}

.orderTable th:nth-child(1),
.orderTable td:nth-child(1) {
  width: 50%;
}

.orderTable th:nth-child(2),
.orderTable td:nth-child(2) {
  width: 10%;
}

.orderTable th:nth-child(3),
.orderTable td:nth-child(3) {
  width: 40%;
}

.orderTable tfoot {
  position: sticky;
  bottom: 0;
  background-color: #DDD4C1;
  z-index: 1;
  border: 3px solid #333;

}

.orderTable tfoot td {
  font-size: 1.5vw;
  font-weight: bold;
  padding: 10px;
  border: 3px solid #333;
  text-align: center;
}

.buttonContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  margin-top: 25px;
}

.backButton {
  background-color: transparent;
  color: #333;
  font-family: '游明朝', serif;
  font-size: 1.5vw;
  padding: 3% 10%;
  border: 2px solid #333;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
}

.confirmButton {
  background-color: #953127;
  color: #FFFFFF;
  font-family: 'HGS明朝B', serif;
  font-size: 1.5vw;
  padding: 3% 10%;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
  white-space: nowrap;
}

.confirmButton:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}
</style>
